export const tabs = [
    { id: 1, name: 'Pro Plans' },
    { id: 2, name: 'Coaches' },
    { id: 3, name: 'Shop' },
    { id: 4, name: 'Reports' }
]